<template>
  <FactureCard>
    <template v-slot:title>Détails de la facture</template>
    <v-data-table light hide-default-footer disable-sort disable-filtering :headers="headers" :items="detailsPretty" dense>
      <template v-slot:body.append="{ isMobile }">
        <template v-if="isMobile && !payable">
          <tr class="v-data-table__mobile-table-row">
            <SousTotalRowMobile title="Total avant taxes" :montant="formatPrix(facture.montantHT)"></SousTotalRowMobile>
            <SousTotalRowMobile v-if="facture.rabais > 0" title="Rabais" :montant="formatRabais(facture.rabais, facture.rabaisType)"></SousTotalRowMobile>
            <SousTotalRowMobile v-for="taxe in facture.taxes" :key="taxe.code" :title="taxe.code" :montant="formatPrix(taxe.montant)"></SousTotalRowMobile>
            <SousTotalRowMobile title="Total" :montant="formatPrix(facture.total)"></SousTotalRowMobile>
            <SousTotalRowMobile title="Déjà payé" :montant="formatPrix(facture.dejaPaye)"></SousTotalRowMobile>
            <SousTotalRowMobile title="Solde" :montant="formatPrix(facture.solde)"></SousTotalRowMobile>
          </tr>
        </template>
        <template v-else-if="!payable">
          <tr>
            <td colspan="4"></td>
          </tr>
          <SousTotalRow title="Total avant taxes" :montant="formatPrix(facture.montantHT)"></SousTotalRow>
          <SousTotalRow v-if="facture.rabais > 0" title="Rabais" :montant="formatRabais(facture.rabais, facture.rabaisType)"></SousTotalRow>
          <SousTotalRow v-for="taxe in facture.taxes" :key="taxe.code" :title="taxe.code" :montant="formatPrix(taxe.montant)"></SousTotalRow>
          <SousTotalRow title="Total" :montant="formatPrix(facture.total)"></SousTotalRow>
          <SousTotalRow title="Déjà payé" :montant="formatPrix(facture.dejaPaye)"></SousTotalRow>
          <SousTotalRow title="Solde" :montant="formatPrix(facture.solde)"></SousTotalRow>
        </template>
      </template>
    </v-data-table>
  </FactureCard>
</template>

<script>
import FactureCard from "./FactureCard"
import SousTotalRow from "./SousTotalRow"
import SousTotalRowMobile from "./SousTotalRowMobile"

export default {
  components: { FactureCard, SousTotalRow, SousTotalRowMobile },
  name: "facture",
  props: {
    facture: Object,
    formatPrix: {
      type: Function,
      default: (montant) => {
        let val = (montant / 1).toFixed(2).replace(".", ",")
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " $"
      }
    },
    formatQuantite: {
      type: Function,
      default: (quantite) => {
        let val = (quantite / 1).toFixed(0)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }
    },
    formatRabais: {
      type: Function,
      default: (montant, type) => {
        return this.formatPrix(montant) + ((type === 'pourcentage') ? ' %' : ' $')
      }
    },
    payable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: "Description", align: "left", sortable: false, value: "libelle" },
        { text: "Prix Unitaire", align: "right", sortable: false, value: "prixUnitaire" },
        { text: "Quantité", align: "right", sortable: false, value: "quantite" },
        { text: "Prix", value: "prix", align: "right", sortable: false }
      ],
    }
  },
  computed: {
    detailsPretty() {
      const result = this.facture.details.map((detail) => {
        return {
          /* eslint-disable no-useless-escape */
          libelle: detail.libelle.replace(/\<br\/\>/g, ""),
          prixUnitaire: this.formatPrix(detail.prixUnitaire),
          quantite: this.formatQuantite(detail.quantite),
          prix: this.formatPrix(detail.prixTotal),
        }
      })
      return result
    },
  },
}
</script>

<style scoped>
</style>